import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import './CareProvidersMap.scss';
import sendEvent from '../../helpers/tracking';
import images from '../../shared/assets/images';
import { sliceLength } from '../../helpers/form';

import Search from '../../shared/assets/icons/search.svg';

const { map } = images;

export default function CareProvidersMap(props) {
  return (
    <section id="careProvidersMap">
      <div id="careProvidersMap_form">
        <h2>Zoek jij nog een zorgverlener voor tijdens jouw zwangerschap?</h2>

        <p>
          Met meer dan 200 aangesloten zorgverleners is zwangerenportaal.nl dé
          verzamelplaats voor alles wat je nodig hebt voor jouw zwangerschap.
        </p>

        <p>Zoek een zorgverlener bij jou in de buurt en schrijf je in!</p>

        <form onSubmit={(e) => search(e)}>
          <input
            type="number"
            autoComplete="off"
            placeholder="Postcode"
            id="careProvidersMap_input"
            onChange={(e) => sliceLength(e.target, 4)}
          />
          <div onClick={(e) => search(e)} id="careProvidersMap_input_icon">
            <Search />
          </div>
        </form>
      </div>

      <div id="careProvidersMap_image">
        <LazyLoadImage alt="map-image" src={map} />
      </div>
    </section>
  );

  function search(e) {
    e.preventDefault();

    const value = document
      .getElementById('careProvidersMap_input')
      .value.trim();

    if (!value) return;

    if (props.eventTrackingCodes) sendEvent(...props.eventTrackingCodes);

    setTimeout(() => (location.href = `/organizations?code=${value}`), 500);
  }
}
